import React from 'react';
import { Row, Col, Button, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './PassengerCounter.css';

const defaultProps = {
  labelTop: '',
  labelBottom: '',
  value: 0
};

const propTypes = {
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  callBack: PropTypes.func.isRequired,
  value: PropTypes.number
};

class PassengerCounter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };

    this.addPassenger = this.addPassenger.bind(this);
    this.removePassenger = this.removePassenger.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentWillMount() {
    this.props.callBack(this.state.value);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value
    });
  }

  handleChange(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || regex.test(e.target.value)) {
      this.setState({ value: e.target.value });
    }
  }

  handleBlur(e) {
    var value = e.target.value;
    var minValue = this.props.minValue;
    var maxValue = this.props.maxValue;
    if (value <= minValue) {
      value = minValue;
    } else if (value >= maxValue) {
      value = maxValue;
    }

    this.setState(
      state => {
        state.value = value;
      },
      () => {
        this.props.callBack(this.state.value);
      }
    );
  }

  addPassenger() {
    var maxValue = this.props.maxValue;
    var actualValue = this.state.value;
    if (actualValue < maxValue) {
      var newValue = Number(actualValue) + 1;
      this.setState(
        state => {
          state.value = newValue;
        },
        () => {
          this.props.callBack(this.state.value);
        }
      );
    }
  }

  removePassenger() {
    var minValue = this.props.minValue;
    var actualValue = this.state.value;
    if (actualValue > minValue) {
      var newValue = Number(actualValue) - 1;
      this.setState(
        state => {
          state.value = newValue;
        },
        () => {
          this.props.callBack(this.state.value);
        }
      );
    }
  }

  render() {
    return (
      <div id={`componentPassengerCounter-${this.props.id}`}>
        <Row>
          <Col xs={7} className="label-top">
            <span> {this.props.labelTop}</span>
          </Col>
          <Col xs={5} smHidden={true} mdHidden={true} lgHidden={true} className="label-top-xs">
            <span> {this.props.labelBottom}</span>
          </Col>
        </Row>
        <Row className="passengerCounter">
          <Col
            xs={4}
            sm={4}
            className={`passengerCounter-box action-button ${
              this.state.value === this.props.minValue ? 'disabled' : ''
            }`}
            onClick={this.removePassenger}>
            <Button
              className="counter-button minus"
              id={`btn-remove-passenger-${this.props.id}`}
              ref={c => (this.btnRemovePassenger = c)}
              disabled={this.state.value === this.props.minValue}>
              <i className="icon-minus" />
            </Button>
          </Col>
          <Col xs={4} sm={4} className="passengerCounter-box">
            <FormControl
              className="counter-input"
              type="text"
              value={this.state.value}
              id={`ipt-passenger-counter-${this.props.id}`}
              ref={c => (this.iptPassegerCounter = c)}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
            />
          </Col>
          <Col
            xs={4}
            sm={4}
            className={`passengerCounter-box action-button ${
              this.state.value === this.props.maxValue ? 'disabled' : ''
            }`}
            onClick={this.addPassenger}>
            <Button
              className="counter-button"
              id={`btn-add-passenger-${this.props.id}`}
              ref={c => (this.btnAddPassenger = c)}
              disabled={this.state.value === this.props.maxValue}>
              <i className="icon-plus" />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xsHidden={true} sm={12} className="label-bottom">
            <span> {this.props.labelBottom}</span>
          </Col>
        </Row>
      </div>
    );
  }
}

PassengerCounter.defaultProps = defaultProps;
PassengerCounter.propTypes = propTypes;

export default PassengerCounter;



// WEBPACK FOOTER //
// ./src/components/searchBox/passengerCounter/PassengerCounter.jsx